import typography from '@assets/theme/base/typography';
import pxToRem from '@assets/theme/functions/pxToRem';

const { size, fontWeightRegular, fontWeightBold } = typography;

const tab = {
  defaultProps: {
    disableRipple: true,
    disableFocusRipple: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: 'transparent' + '!important',
      alignItems: 'flex-center',
      minWidth: '130px !important',
      fontSize: size.lg,
      fontWeight: fontWeightRegular,
      textTransform: 'none',
      lineHeight: 'inherit',
      color: '#000',
      opacity: '1 !important',
      padding: '5px',
      border: '3px solid black !important',

      ':focus, :hover': {
        fontWeight: fontWeightBold,
      },

      '& .material-icons, .material-icons-round': {
        marginBottom: '0 !important',
        marginRight: pxToRem(6),
      },

      '& svg': {
        marginBottom: '0 !important',
        marginRight: pxToRem(6),
      },

      '&.Mui-selected': {
        color: '#000 !important',
        backgroundColor: `rgba(${theme.vars.palette.secondary.mainChannel} / 0.85) !important`,
        fontWeight: fontWeightBold,
      },
    }),

    labelIcon: {
      paddingTop: pxToRem(4),
    },
  },
};

export default tab;
